import { ComboBox, InputMaskField, TextInput, Button } from '@components';
import { genres, marital } from '@utils';
import { Field, useFormikContext } from 'formik';
import React, { useEffect } from 'react';

export const DadosPessoaisForm = ({ isEdit, setIsEdit, isActive }) => {
  const { resetForm, setTouched } = useFormikContext();

  useEffect(() => {
    if (isEdit && isActive) {
      setTouched(
        {
          sexo: true,
          nacionalidade: true,
          rg: true,
          estadoCivil: true,
          pai: true,
          mae: true,
        },
        true
      );
    }
  }, [isActive, isEdit, setTouched]);

  return (
    <div className="row">
      <div className="col-md-12">
        {isEdit && (
          <div className="d-flex justify-content-between mt-4 mb-4">
            <h3 className="mb-32 ts-16 fw-bold">
              Editando: Dados Pessoais
              <div className="row">
                <p className="text-orange ts-16 mt-2">
                  Atenção: para salvar suas alterações, você precisa avançar até
                  a última etapa do formulário.
                </p>
              </div>
            </h3>
            <div className="col-md-2 d-flex justify-content-end">
              <Button
                type="button"
                color="orange"
                transparent
                onClick={() => {
                  setIsEdit(false);
                  resetForm();
                }}
                className="d-flex justify-content-center"
              >
                Cancelar edição
              </Button>
            </div>
          </div>
        )}
      </div>
      <div className="col-md-12 col-lg-6">
        <Field
          name="nome"
          className="mb-3"
          disabled
          component={TextInput}
          label="Nome completo"
        />
        <Field
          name="dtNascimento"
          className="mb-3"
          disabled
          mask="11/11/1111"
          inputMode="numeric"
          component={InputMaskField}
          label="Data de nascimento"
        />
        <Field
          className="mb-3"
          disabled
          name="cpf"
          mask="111.111.111-11"
          inputMode="numeric"
          component={InputMaskField}
          label="CPF"
        />
        <Field
          name="sexo"
          className="mb-3"
          component={ComboBox}
          disabled={!isEdit}
          label="Gênero"
          options={genres.map((s) => {
            return { value: s, label: s };
          })}
        />
        <Field
          name="nacionalidade"
          className="mb-3"
          disabled={!isEdit}
          component={TextInput}
          label="Nacionalidade"
        />
        <Field
          name="estadoNasc"
          className="mb-3"
          disabled
          component={TextInput}
          label="Estado de nascimento"
        />
      </div>
      <div className="col-md-12 col-lg-6 mt-md-4 mt-lg-0">
        <Field
          className="mb-3"
          disabled={!isEdit}
          name="rg"
          component={TextInput}
          label="Documento de Identificação (DI)"
        />

        <Field
          name="estadoCivil"
          className="mb-3"
          disabled={!isEdit}
          component={ComboBox}
          label="Estado Civil"
          options={marital.map((s) => {
            return { value: s, label: s };
          })}
        />
        <Field
          name="pai"
          className="mb-3"
          disabled={!isEdit}
          component={TextInput}
          label="Pai"
        />
        <Field
          name="mae"
          className="mb-3"
          disabled={!isEdit}
          component={TextInput}
          label="Mãe"
        />
        <Field
          name="localNascimento"
          className="mb-3"
          disabled
          component={TextInput}
          label="Local de nascimento"
        />
      </div>
    </div>
  );
};
